import React from 'react';

const Footer = () => <footer className="footer" />;

export default Footer;
